import React from "react";
import * as runtimeConstants from "./runtime-constants";

declare global {
  interface Window {
    constants?: {
      [key: string]: string;
    };
  }
}

const getConstantsAsScript = () => {
  return Object.entries(runtimeConstants)
    .map(([key, value]) => `window.constants.${key} = "${value || ""}";`)
    .join("\n");
};

export const ConstantsProvider = () => {
  const constantsScript = `
    window.constants = {};
    ${getConstantsAsScript()}
  `;

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: constantsScript,
        }}
        id="constants"
      />
    </>
  );
};

export const getIsomorphicConstant = (name: string) => {
  if (typeof window !== "undefined" && window.constants) {
    return window.constants[name];
  }
  return process?.env?.[name];
};
